import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

const pageStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundImage: "url(/office-bg.png)",   // put your image in public/office-bg.jpg
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const cardStyle = {
  width: 460,
  maxWidth: "90vw",
  padding: "32px 40px",
  borderRadius: 24,
  background: "rgba(255, 255, 255, 0.16)",
  border: "1px solid rgba(255, 255, 255, 0.4)",
  backdropFilter: "blur(18px)",
  boxShadow: "0 18px 60px rgba(0,0,0,0.35)",
  color: "#133041",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};


export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const ALLOWED_DOMAIN = "fanisko.com";

const handleSuccess = (credentialResponse) => {
  const idToken = credentialResponse.credential;
  const decoded = jwtDecode(idToken);

  const email = decoded.email;
  const emailVerified = decoded.email_verified; // boolean

  const domain = email?.split("@")[1];

  if (!email || !emailVerified || domain !== ALLOWED_DOMAIN) {
    alert("Only fanisko domain emails are allowed");
    return;
  }

  // Passed checks → mark user as logged in
  login({
    name: decoded.name,
    email,
    picture: decoded.picture,
    sub: decoded.sub,
  });

  navigate("/hr");
};

  const handleError = () => {
    console.log("Google login failed");
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h2 style={{ letterSpacing: 2, marginBottom: 8 }}>RECRUIT ASSIST</h2>
        <p style={{ marginBottom: 24, fontSize: 13, opacity: 0.9 }}>
          Login by your consent
        </p>

        <GoogleLogin onSuccess={handleSuccess} onError={handleError} />

        <p style={{ marginTop: 20, fontSize: 12, opacity: 0.9 }}>
          By signing in you agree to our terms &amp; privacy.
        </p>
      </div>
    </div>
  );
}
